import * as Sentry from "@sentry/angular";
import { Component, HostListener, OnInit } from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Title} from "@angular/platform-browser";
import { TokenStorageService } from './authentication/storages/token-storage.service';
import { PermissionStorageService } from './authentication/storages/permission-storage.service';
import { ResourceIteratorPipe } from '@progress/kendo-angular-scheduler';
import { TranslocoService } from '@jsverse/transloco';
import { TenantSettingsStoreService } from './setting/tenant-settings/services/tenant-settings-store.service';
import { UserSettingsStoreService } from './user-settings/services/user-settings-store.service';
import { PwaUpdateService } from './shared/services/pwa-update.service';
import { AppStateInterface } from './stores/global/appState.interface';
import { select, Store } from '@ngrx/store';
import { currentEmployeeSelector, getCurrentEmployee } from './stores/global/current-employee/current-employee.store';
import { combineLatest, map, tap } from 'rxjs';
import { documentationLinks } from '../environments/documentationLinks';
import { VersionService } from "./core/services/version.service";
import { appVersion } from 'src/environments/version';
import { ExpenseStoreService } from './expenses/storage/expense-store.service';
import { hasRouteAccess } from './shared/helpers/route-permissions';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent implements OnInit{
  title = 'quick planner';

  public documentationLinks = documentationLinks;

  public items: Array<{ [Key: string]: unknown }> = [];

  currentUrl: string = window.location.pathname.substring(1);

  isExpanded = true;

  isActive = false;

  collapseMenuAfterClick = false;

  version = appVersion.version;

  constructor(
    public router: Router,
    private titleService: Title,
    private tokenStorageSerivce : TokenStorageService,
    private permissionStorage : PermissionStorageService,
    private route: ActivatedRoute,
    private translocoService: TranslocoService,
    private tenantSettingsStore: TenantSettingsStoreService,
    private userSettingsStore: UserSettingsStoreService,
    private pwaUpdateService: PwaUpdateService,
    private store: Store<AppStateInterface>,
    private expenseStore: ExpenseStoreService
  ) { }

  // Number of expenses the current user still has to review (nav badge).
  expenseReviewCount$ = this.expenseStore.toReviewCount$;

  ngOnInit(){
    this.router.events.subscribe((event) => {
      if(event instanceof NavigationEnd) {
        if(this.router.url != '/auth') {
          this.isActive = true;
          this.generateMenuItems();
        } else {
          this.isActive = false;
        }
      }
    });

    this.initStoragesAsLoggedInUser();
    
    // React to permission changes
    this.permissionStorage.permissions$.subscribe(() => {
      if(this.isActive) {
        this.generateMenuItems();
      }
    });
  }

    vm$ = combineLatest([
      this.store.pipe(select(currentEmployeeSelector)).pipe(
        tap(employee => {
          if(employee){
            Sentry.setUser({ email: `${employee?.email}` })
          }
        })
      )
    ]).pipe(
      map(([
        currentEmployee,
      ]) => ({
        currentEmployee,
      }))
    );

  initStoragesAsLoggedInUser(){
    if(this.tokenStorageSerivce.getToken()){
      this.store.dispatch(getCurrentEmployee())
      this.tenantSettingsStore.getCurrentTenantSettings();
      this.userSettingsStore.getCurrentUserSettings();
      this.expenseStore.loadToReviewCount();
    }
  }

  @HostListener('window:resize', ['$event'])
  setMenuState(event?){
    var scrWidth = window.innerWidth;
    console.log(scrWidth, "screen wdith");

    if(scrWidth < 600){
      this.isExpanded = false;
      this.collapseMenuAfterClick = true;
    } else {
      this.isExpanded = true;
      this.collapseMenuAfterClick = false;
    }
  }

  public setTitle(newTitle: string = this.title) {
    this.titleService.setTitle(newTitle);
  }

  onLogout(){
    this.tokenStorageSerivce.signOut();
    // Full reload so no previous user's data lingers in memory: this discards the NgRx store and
    // every in-memory (BehaviorSubject) store, which a soft router navigation would keep alive.
    window.location.href = '/auth';
  }

  generateMenuItems(){
    this.items = [];
    const routes: any[] = this.router.config;
    const permissions = this.permissionStorage.getPermissions() ?? [];
    
    routes.forEach((route) => {
      // Same rule as the AuthGuard, so every visible item is an enterable page: routes
      // without a declared permission are open, hubs derive access from their children.
      if (route.data?.title && hasRouteAccess(route, permissions)){

        // sub Components dont work -> parent url is in pluar und child is singular and does not contain parent url part.

          this.items.push({
            text: route.data.title,
            path: route.path ? route.path : "",
            children: route.children ? true : false,
            selected: (() => {
              if (route.path === '') return this.router.url === '/';
              const segment = this.router.url.split('/')[1];
              if (!segment) return false;
              return segment.startsWith(route.path.replace(/s$/, ''))
                || route.path.startsWith(segment);
            })(),
          });

          if(route.path === this.router.url.slice(1)){
            this.setTitleTag(route.data.title)
          }

          // if (route.children){
  
          //   route.children.forEach((child: { data: { title: any; level: any; }; path: any; }) => {
          //     this.items.push({
          //       text: child.data.title,
          //       path: child.path ? route.path + '/' + child.path : "",
          //       level: child.data.level,
          //       selected: route.path + '/' + child.path === this.router.url.slice(1) ? true : false,
          //     })
          //   })
          // }
      }
      
    });

    this.setMenuState();
  }

  setTitleTag(pageName : string){
    this.titleService.setTitle(pageName + " | quick planner");
  }

}
